import { FontTheme } from '../types';

export default {
  fa: require('./fa').default as FontTheme,
};
